import AuthorizationModal from './AuthorizationModal'

export default AuthorizationModal


// WEBPACK FOOTER //
// app/javascript/components/AuthorizationModal/index.js